import { Flex, Text } from '@chakra-ui/layout'
import { Component, ErrorInfo, ReactNode } from 'react'

export interface ErrorBoundaryProps {
  children?: ReactNode
  renderError?: (error: Error) => ReactNode
}

interface ErrorBoundaryState {
  error: Error | false
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { error: false }
  }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error)
    if (errorInfo?.componentStack) {
      console.error('ErrorBoundary component stack:', errorInfo.componentStack)
    }
  }

  render() {
    const { error } = this.state

    if (!error) {
      return this.props.children
    }

    if (this.props.renderError) {
      return this.props.renderError(error)
    }

    return (
      <Flex
        alignItems="center"
        justify="center"
        bg="red.100"
        rounded="lg"
        p="3"
      >
        <Text fontSize="xl" color="red.800">
          {error?.message ?? 'Something went wrong'}
        </Text>
      </Flex>
    )
  }
}
